import { Container } from "react-bootstrap";
import Content from "Types/Content";
import BitbucketDeploymentSettingsImg from "./BitbucketDeploymentSettingsImg.png";
import BitbucketDeploymentEnviromentSettingsImg from "./BitbucketDeploymentEnviromentSettingsImg.png";
import DeploymentPipelineExample from "./DeploymentPipelineExample.png";
import BtibucketDeploymentScreenImg from "./BtibucketDeploymentScreenImg.png";

const Deployment: React.FC = () => {
  return (
    <Container className='pt-3 d-flex flex-column'>
      <h1>
        <a href='https://www.atlassian.com/continuous-delivery/tutorials'>
          Deployment
        </a>
      </h1>
      <p>
        Las metodologías ágiles de desarrollo dependen en gran medida de la
        capacidad del equipo para realizar entregas de manera continua, dinámica
        y robusta. Para poder realizar eso, en crombie realizamos entregables en
        tres canales diferentes, los cuales deberían estar configurados en todo
        proyecto en bitbucket:
      </p>
      <ul>
        <li>
          <strong>Staging</strong>: Este canal canaliza las entregas más
          continuas, y las más cercanas al equipo de desarrollo, está pensado
          para que el equipo interno pueda hacer revisiones parciales de lo que
          se va entregando. Idealmente, toda integración a la rama develop debe
          verse reflejada en staging.
        </li>
        <li>
          <strong>Test</strong>: El canala Test nos sirve para realizar entregas
          parciales al cliente, una vez que se juntarons suficientes avances
          como parea hacer un entregable, se debe enviar una entrega a Test para
          que el cliente pueda ver y dar un feedback. Idealmente, toda
          integración a la rama master debe verse reflejada en Test.
        </li>
        <li>
          <strong>Production</strong>: Una vez que algo fue revisado en el
          equipo interno, y se validó con el cliente, se debe hacer un deploy a
          Production. Esta entrega es mejor que se de manualmente (con un custom
          pipeline) por su naturaleza esporádica.
        </li>
      </ul>
      <h2>Configuración en Bitbucket</h2>
      <p>
        Si bien estos canáles son definidos de manera conceptual, es importante
        que se vean materializados en nuestro entorno, para poder automatizár el
        flujo definido y lograr un proceso de desarrollo con integración
        continua (ci/cd).
      </p>
      <p>
        Bitbucket por defecto ya define los tres canales que utilizamos en
        Crombie para trabajar, en esos tres canales podemos crear entornos
        nuevos, o utilizar los que vienen por defecto. (staging, test,
        production).
      </p>
      <img
        width={500}
        alt='Imagen de ajustes de deployment en Bitbucket'
        src={BitbucketDeploymentSettingsImg}
        className='mw-100 align-self-center mb-2'
      />
      <p>
        Si entras a la configuración de un entorno en especifico, vas a ver que
        Bitbucket te permite definir un conjunto de variables que van a ser
        accessibles por el pipeline que defina el deploy a dicho entorno. En
        nuestro caso, aprovechamos este lugar para definir las variables para
        conectarnos al servidor en donde se realice el deployment. (Aquí{" "}
        <strong>no</strong> se guardan las claves ssh para conectarse al
        servidor, eso se guarda en otro parte.).
      </p>
      <img
        width={500}
        alt='Imagen de ajustes de un entorno de deployment en Bitbucket'
        src={BitbucketDeploymentEnviromentSettingsImg}
        className='mw-100 align-self-center mb-2'
      />
      <p>
        Un deployment en Bitbucket es en realidad un "step" en un pipeline, el
        cual asociamos a un deployment definido previamente, que define un
        script o pipe a ejecutar para realizar dicho deployment. A continuación
        un ejemplo:
      </p>
      <img
        width={500}
        alt='Imagen de ejemplo de un pipeline que ejecuta un deployment'
        src={DeploymentPipelineExample}
        className='mw-100 align-self-center mb-2'
      />
      <p>
        Una vez definido el pipeline adecuadamente para que ejecute nuestro
        deployment, y le asignamos un deployment previamente configurado en
        Bitbucket, dentro de la sección de Deployments en nuestro repositorio
        podremos ver algo como esto:
      </p>
      <img
        width={500}
        alt='Imagen de pantalla de deployments en Bitbucket'
        src={BtibucketDeploymentScreenImg}
        className='mw-100 align-self-center'
      />
    </Container>
  );
};

export default new Content({
  Component: Deployment,
  title: "Deployment",
  route: "deployment",
  tags: [
    "git",
    "gitflow",
    "version",
    "version control",
    "bitbucket",
    "repository",
    "continous",
    "integration",
    "ci",
    "cd",
    "ci/cd",
    "pipeline"
  ]
});
